import { settings } from "./settings";

export function observable<T = void>(object?: T extends void ? any : Partial<T>, options?: {autoMarkDirty?: boolean} ) {
    options = options || {};

    var obs = kendo.observable(object);

    if (options.autoMarkDirty) {
        obs.bind("change", function () {
            obs.dirty = true;
        });
    }

    obs.zClean = function () {
        obs.dirty = false;
    };

    return obs as T extends void ? kendo.data.ObservableObject : kendo.data.TypedObservableObject<T>;
}

export function assign(obj, keyPath, value) {
    var lastKeyIndex = keyPath.length - 1;
    for (var ii = 0; ii < lastKeyIndex; ++ii) {
        var key = keyPath[ii];
        if (!(key in obj)) {
            obj[key] = {};
        }
        obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;

    return obj;
}

type ContainerType = string | JQuery;
export interface BindObject {
    container: ContainerType; // Either a string or a JQuery.
    data?: object;
    bind; // Either a string or a JQuery. But must be allowed to act as both.
    unbind?: boolean;
    setDataToNull?: boolean;
}

/**
 * @param bindObject Options on what to bind and how to bind it.
 * See interface BindObject for more information.
 */
export function bind(bindObject: BindObject) {

    var jqueryResults = $(bindObject.container).find(bindObject.bind);

    if (jqueryResults.length < 1 && settings.showDebugMessages) {
        // z.controls.alert({
        //     header: "Warning",
        //     type: "warning",
        //     message: "Cannot z.bind on this bindObject, it's selector returns an empty array of DOM elements",
        //     wait: 1000
        // });
        return;
    }

    $(bindObject.container).find(bindObject.bind).data("bindData", bindObject.data);
    $(bindObject.container).data("bindData", bindObject.data);

    if (bindObject.unbind) {
        if (bindObject.setDataToNull) {
            kendo.bind($(bindObject.container).find(bindObject.bind), null);
        }
        kendo.unbind($(bindObject.container).find(bindObject.bind));
    } else {
        var checkboxes = jqueryResults.filter(".checkbox-input");

        $.each(checkboxes, function (index, checkbox) {
            var input = $(checkbox);
            if (input.attr("id").indexOf("UDF") != -1) {
               input.trigger("zCheckboxBind");
            }
        });

        kendo.bind($(bindObject.container).find(bindObject.bind), bindObject.data);
        let linkedInputs = jqueryResults.siblings().find(".linked-input");
        if (linkedInputs.length > 0) {
            kendo.bind(linkedInputs, bindObject.data);
        }
    }

    var links = $(bindObject.container).find(".linked-input");
    if (links.length > 0) {
        var identifier = $("#" + links[0].id);

        $.each(identifier, function (index, obj) {
            var linkControl = $(obj),
                linked = linkControl.prop("checked"),
                parentComponentData = linkControl.data("parentComponent"),
                parentComponent = $("#" + parentComponentData.id),
                sourceControl = $("#" + parentComponentData.options.zScreen.id + "_" + parentComponentData.options.linkedTo);

            if (linked) {
                parentComponent.readOnly(true);

                sourceControl.off("change.linkedControl").tie("change.linkedControl", function () {
                    parentComponent.val(sourceControl.val());
                    parentComponent.change();
                });
            } else {
                parentComponent.readOnly(false);
                sourceControl.off("change.linkedControl");
            }
        });
    }

    var comboBoxes = jqueryResults.filter(".k-widget.k-combobox.pane-field-input");

    $.each(comboBoxes, function (index, combo) {
        var kcb = $(combo).children(".pane-field-input").data("kendoComboBox");
        if (kcb) {
                kcb.trigger("zRefresh");
        }
    });

}

kendo.ui.Grid.prototype._dirtyIndicatorTemplate = function () {
    return "";
};

kendo.ui.Grid.prototype._dirtyCellTemplate = kendo.ui.Grid.prototype._dirtyIndicatorTemplate;

// Kendo now reorders the column list every time the grid column context menu is opened.
// This breaks our customizations. Maybe with all of our customizations we should implement
// a completely custom context menu at some point in the future.
(kendo.ui as any).ColumnMenu.prototype._reorderColumnList = () => {};

const originalExpr = (kendo as any).expr;
function fixedExpr(expression, safe, paramName) {
    // safe is optional, so if the second argument is a string it is actually the paramName
    safe = safe === undefined ? true : safe;
    return originalExpr(expression, safe, paramName);
}

/**
 * Helper function for when Kendo breaks something and their code no longer passes the "safe" flag to kendo.expr when it used to.
 * Call restoreExpr() when the broken code is done with.
 */
export function setExprAlwaysSafe() {
    (kendo as any).expr = fixedExpr;
}

/**
 * Restores the original version of kendo.expr.
 */
export function restoreExpr() {
    (kendo as any).expr = originalExpr;
}
